import { render, staticRenderFns } from "./rate-highlights.vue?vue&type=template&id=b3d9e4b0&scoped=true"
import script from "./rate-highlights.vue?vue&type=script&lang=js"
export * from "./rate-highlights.vue?vue&type=script&lang=js"
import style0 from "./rate-highlights.vue?vue&type=style&index=0&id=b3d9e4b0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d9e4b0",
  null
  
)

export default component.exports